<template>
  <div>
    <v-dialog
      v-show="changePlanDialog"
      v-model="changePlanDialog"
      persistent
      max-width="1200px"
      v-scroll-lock="!changePlanDialog"
    >
      <v-card>
        <v-card-title class="headline justify-center">
          <span class="mt-3">
            Choose your Plans
          </span>
        </v-card-title>
        <template name="plansTable">
          <plans-table
            :plans="plans"
            :myPlan="myPlan"
            :loadingChangePlan="loadingChangePlan"
            :team="team"
            @choose="choose"
          ></plans-table>
        </template>
        <v-row style="margin-left: 30px;">
          <v-btn class="mb-5" color="error" @click="setChangePlanDialog(false)">
            Close
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadingChangePlan" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Now processing...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <confirm-dialog ref="confirm"></confirm-dialog>
  </div>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import PlansTable from '@/components/subscription/PlansTable.vue'

export default {
  name: 'ChangePlanDialog',
  components: {
    ConfirmDialog,
    PlansTable,
  },
  props: {
    changePlanDialog: {
      type: Boolean,
      default: false,
    },
    myPlan: {
      type: Object,
      required: true,
    },
    plans: {
      type: Array,
      required: true,
    },
    team: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loadingChangePlan: false,
    }
  },
  methods: {
    setChangePlanDialog(show) {
      this.$emit('setChangePlanDialog', show)
    },
    async choose(name) {
      if (
        await this.$refs.confirm.open(
          'You are attempting to change your subscription plan.',
          'Continue'
        )
      ) {
        this.loadingChangePlan = true
        const result = await this.postMyPlan(name)
        if (!result) {
          // Do nothing and continue the process.
        }
        this.loadingChangePlan = false
        this.$emit('init')
        this.$emit('setChangePlanDialog', false)
      }
    },
  },
  mounted() {},
}
</script>
